import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';

import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    STORE_DESIGNPREFERENCES_DATA,
    DesignPreferencesData,
    CustDPrefData,
    STORE_CUST_DESIGNPREFERENCE_DATA,
    STORE_CUST_DESIGNPREFERENCE_DATA_INITIAL,
} from 'src/reducers/editDesignPreference';
import { push } from 'react-router-redux';
import { STORE_ERROR_FILES_UPLOADED, STORE_ERROR_FILES_UPLOADED_MSG, STORE_SUCCESS_FILES_UPLOADED_MSG, STORE_SUCCESS_FILES_UPLOADED } from 'src/reducers/errors';

// export const getdesignPreferencesData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     console.log(getState().user.userDetails.s, 'session ID');
//     axios({
//         method: 'get',
//         url: `${getState().environment.API_URL}getDesignCodes`,
//         headers: {
//             sessionid: getState().user.userDetails.s || ''
//         },
//     }).then(function (response: AxiosResponse) {

//         const num = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26'];
//         const designPreferencesData: Array<Array<DesignPreferencesData>> = [];
//         num.map((it, inde) => {
//             designPreferencesData[inde] = response.data.filter((item: DesignPreferencesData) => {
//                 return item.listcode === it;
//             });
//             designPreferencesData.join();
//         });
//         dispatch({ type: STORE_DESIGNPREFERENCES_DATA, designPreferencesData } as AnyAction);
//     }).catch(function (error: AxiosError) {
//         // ==> console.error(error);
//     });
// };

export const getdesignPreferencesData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    axios({
        method: 'get',
        url: `${getState().environment.API_URL}getPreference`,
        // url: `http://localhost:3018/getPreference`,
        headers: {
            sessionid: getState().user.userDetails.s || ''
        },
    }).then(function (response: AxiosResponse) {
        const designPreferencesData: Array<DesignPreferencesData> = response.data;
        // designPreferencesData();
        dispatch({ type: STORE_DESIGNPREFERENCES_DATA, designPreferencesData } as AnyAction);
    }).catch(function (error: AxiosError) {
        // ==> console.error(error);
    });
};

// export const updatePreferences = (parentcode: string, listtype: string, value: string, listCode: number) => {
//     return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//         const custDPrefDataEdit = [...getState().editDesignPreferences.custDPrefData];
//         const allData = [...getState().editDesignPreferences.designPreferencesData];
//         const designData = allData;
//         custDPrefDataEdit[listCode - 1].valuecode = designData[0].valuecode;
//         custDPrefDataEdit[listCode - 1].valuedesc = designData[0].valuedesc;

//         const custDPrefData = custDPrefDataEdit;
//         dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData } as AnyAction);
//     };
// };

// export const updatePreferences = (
//     parentcode: string,
//     listtype: string,
//     value: string,
//     listCode: number,
// ) => {
//     return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
//         const editDesignPreferences = getState().editDesignPreferences;

//         // Ensure custPref array is properly initialized
//         if (!editDesignPreferences || !editDesignPreferences.custDPrefData || !Array.isArray(editDesignPreferences.custDPrefData)) {
//             console.error('custPref is not properly initialized or is not an array.');
//             return;
//         }

//         const custDPrefDataEdit: CustDPrefData[] = [...editDesignPreferences.custDPrefData];

//         // Find the entry in custPref array corresponding to the listtype
//         const entryToUpdate = custDPrefDataEdit.find(entry => entry.listtype === listtype);

//         // Update the valuecode and valuedesc properties of the found entry
//         if (entryToUpdate) {
//             entryToUpdate.valuecode = value; // Assuming the value directly corresponds to valuecode
//             // You can also update valuedesc if you have corresponding description available
//             // entryToUpdate.valuedesc = ...; 
//         }

//         dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData: custDPrefDataEdit } as AnyAction);
//     };
// };

// export const updatePreferences = (
//     parentcode: string,
//     listtype: string,
//     value: string,
//     selectedValueDesc: string,
// ) => {
//     return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
//         const editDesignPreferences = getState().editDesignPreferences;

//         if (!editDesignPreferences || !editDesignPreferences.custDPrefData || !Array.isArray(editDesignPreferences.custDPrefData)) {
//             console.error('editDesignPreferences or custDPrefData is not properly initialized or is not an array.');
//             return;
//         }

//         // Clone the custDPrefData array
//         const custDPrefDataEdit: CustDPrefData[] = [...editDesignPreferences.custDPrefData];
//         const entryToUpdate = custDPrefDataEdit.find(entry => entry.listtype === listtype);

//         if (entryToUpdate) {
//             entryToUpdate.valuecode = value;
//             entryToUpdate.valuedesc = selectedValueDesc;
//             entryToUpdate.other = selectedValueDesc === 'Any Other Value (In MM)' ? 'T' : 'F';
//         } else {
//             const newEntry: CustDPrefData = {
//                 rowno: '',
//                 customer: '',
//                 customersbu: '',
//                 listcode: '',
//                 listtype: listtype,
//                 valuecode: value,
//                 valuedesc: selectedValueDesc,
//                 recordid: '0',
//                 customerpreferencedtlid: '0',
//                 other: selectedValueDesc === 'Any Other Value (In MM)' ? 'T' : 'F'
//             };
//             custDPrefDataEdit.push(newEntry);
//         }
//         dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData: custDPrefDataEdit });
//     };
// };

// export const updatePreferences = (
//     parentcode: string,
//     listtype: string,
//     value: string,
//     selectedValueDesc: string,
//     fieldvalue: string
// ) => {
//     return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
//         const editDesignPreferences = getState().editDesignPreferences;

//         if (!editDesignPreferences || !editDesignPreferences.custDPrefData || !Array.isArray(editDesignPreferences.custDPrefData)) {
//             console.error('custPref is not properly initialized or is not an array.');
//             return;
//         }

//         // Clone the custDPrefData array
//         const custDPrefDataEdit1: CustDPrefData[] = [...editDesignPreferences.custDPrefData];
        
//         const entryToUpdate = custDPrefDataEdit1.find(entry => entry.listtype === listtype);

//         const custDPrefDataEdit = editDesignPreferences.custDPrefData.map(entry => {
//             if (entry.listtype === listtype) {
//                 return {
//                     ...entry,
//                     valuecode: value,
//                     // valuedesc: '',
//                     fvaluedesc: selectedValueDesc,
//                     othervalue: selectedValueDesc === 'Others' ? fieldvalue : '',  // Update or clear othervalue
//                     // fothervalue: fieldvalue  // Sync fothervalue to fieldvalue
//                 };
//             }
//             return entry;
//         });

//         if (!custDPrefDataEdit.some(entry => entry.listtype === listtype)) {
//             custDPrefDataEdit.push({
//                 rowno: '',
//                 customer: '',
//                 customersbu: '',
//                 listcode: '',
//                 listtype,
//                 valuecode: value,
//                 // valuedesc: '',
//                 fvaluedesc: selectedValueDesc,
//                 recordid: '0',
//                 customerpreferencedtlid: '0',
//                 other: '',
//                 othervalue: selectedValueDesc === 'Others' ? fieldvalue : '',
//                 fothervalue: ''
//             });
//         }

//         dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData: custDPrefDataEdit });
//     };
// };

export const updatePreferences = (
    parentcode: string,
    listtype: string,
    value: string,
    selectedValueDesc: string,
    fieldvalue: string
) => {
    return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
        const editDesignPreferences = getState().editDesignPreferences;

        if (!editDesignPreferences || !editDesignPreferences.custDPrefData || !Array.isArray(editDesignPreferences.custDPrefData)) {
            console.error('custPref is not properly initialized or is not an array.');
            return;
        }

        // Clone the custDPrefData array
        const custDPrefDataEdit1: CustDPrefData[] = [...editDesignPreferences.custDPrefData];
        
        // Find the entry to update
        // const entryToUpdate = custDPrefDataEdit1.find(entry => entry.listtype === listtype);

        // Update the custDPrefData array
        const custDPrefDataEdit = custDPrefDataEdit1.map(entry => {
            if (entry.listtype === listtype) {
                return {
                    ...entry,
                    valuecode: value,
                    fvaluedesc: selectedValueDesc, // Correctly update fvaluedesc
                    valuedesc: selectedValueDesc === 'Others' ? fieldvalue : selectedValueDesc, // Correctly update valuedesc
                    othervalue: selectedValueDesc === 'Others' ? fieldvalue : '',  // Update or clear othervalue
                };
            }
            return entry;
        });

        // If the entry is not found, add a new entry
        if (!custDPrefDataEdit.some(entry => entry.listtype === listtype)) {
            custDPrefDataEdit.push({
                rowno: '',
                customer: '',
                customersbu: '',
                listcode: '',
                listtype,
                valuecode: value,
                valuedesc: selectedValueDesc === 'Others' ? fieldvalue : selectedValueDesc,
                fvaluedesc: selectedValueDesc,  // Set fvaluedesc here as well
                recordid: '0',
                customerpreferencedtlid: '0',
                other: '',
                othervalue: selectedValueDesc === 'Others' ? fieldvalue : '',
                fothervalue: ''
            });
        }

        // Dispatch the updated state
        dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData: custDPrefDataEdit });
    };
};

export const goEditDesignPreference = (sbu: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const params = {
            pcustcode: getState().user.userDetails.labCode,
            pcustsbu: sbu
        };

        try {
            const response = await axios.post(
                `${getState().environment.API_URL}getCustDesignPreferences`,
                params,
                {
                    headers: {
                        sessionid: getState().user.userDetails.s || ''
                    }
                }
            );

            let custDPrefDataApi: Array<CustDPrefData> = [];

            if (response.data && response.data.length > 0) {
                custDPrefDataApi = response.data;
            }

            dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData: custDPrefDataApi });

            dispatch(push('/app/editdesignpreferences'));

        } catch (error) {
            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen });
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg });
        }
    };
};

// export const goEditDesignPreference = (sbu: string) => {
//     return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//         const params = {
//             pcustcode: getState().user.userDetails.labCode,
//             pcustsbu: sbu
//         };

//         axios({
//             method: 'post',
//             url: `${getState().environment.API_URL}getCustDesignPreferences`,
//             headers: {
//                 sessionid: getState().user.userDetails.s || ''
//             },
//             data: params
//         }).then(function (response: AxiosResponse) {

//             const num = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26'];
//             const custDPrefDataApi: Array<Array<CustDPrefData>> = [];
//             num.map((it, inde) => {
//                 console.log('res-cust', response.data);
//                 if (response.data[inde]) {
//                     custDPrefDataApi[inde] = response.data.filter((item: CustDPrefData) => {
//                         return item.listcode === it;
//                     });
//                 } else {
//                     const apiRefData = [
//                         {
//                             rowno: it,
//                             customer: '',
//                             customersbu: '',
//                             listcode: '',
//                             listtype: '',
//                             valuecode: '',
//                             valuedesc: '',
//                             recordid: '0',
//                             customerpreferencedtlid: '0'
//                         },
//                     ];
//                     custDPrefDataApi[inde] = apiRefData;
//                 }
//             });
//             console.log('concat-before', custDPrefDataApi);
//             const custDPrefData: CustDPrefData[] = [].concat.apply([], custDPrefDataApi);

//             dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA, custDPrefData } as AnyAction);

//             console.log('update-fetch', custDPrefData);

//             dispatch(push('/app/editdesignpreferences'));

//         }).catch(error => {

//             const errorFileUploadedOpen = true;
//             const errorfilemsg = error.response.data.msg;
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//         });
//     };
// };
export const designPreferencesUpdate = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const custData = [...getState().editDesignPreferences.custDPrefData];

    const recid = custData.filter((recId) => recId.recordid !== '');

    // Check for entries with 'Other' in valuedesc and empty fieldvalue
    const othersdata = custData.filter((data) => 
        (data.fvaluedesc === 'Others')
    );

    // Check if any "Other" entries have empty othervalue
    const hasEmptyOtherValue = othersdata.some(data => 
        !data.othervalue || data.othervalue.trim() === ''
    );

    // Show error if there are entries with empty othervalue
    if (hasEmptyOtherValue) {
        const errorFileUploadedOpen = true;
        const errorfilemsg = `Please enter values for other selection`;
        // const errorfilemsg = `Please enter values for all other selections`;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        return;
    } else {
        const errorFileUploadedOpen = false;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorFileUploadedOpen } as AnyAction);
    }

    const updateCust = {
        preferenceId: recid.length > 0 ? recid[0].recordid : '0',
        columns: {
            customer: getState().user.userDetails.labCode,
            customersbu: getState().fileUpload.branchType,
        },
        custPref: custData
    };

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}updateCustPreferences`,
        // url: 'http://localhost:3018/updateCustPreferences',
        headers: {
            sessionid: getState().user.userDetails.s || ''
        },
        data: updateCust
    }).then(function (response: AxiosResponse) {

        const custDPrefDataInitial = [...getState().editDesignPreferences.custDPrefData];
        dispatch({ type: STORE_CUST_DESIGNPREFERENCE_DATA_INITIAL, custDPrefDataInitial } as AnyAction);

        const successFileUploadOpen = true;
        const successfilemsg = response.data.msg;
        dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
        dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

        dispatch(push('/app/designpreference'));

    }).catch(error => {

        const errorFileUploadedOpen = true;
        const errorfilemsg = error.response.data.msg;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

    });
};

export const resetCustPreferences = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    dispatch(push('/app/designpreference'));
};



// WEBPACK FOOTER //
// ./src/actions/editDesignPreferenceAction.ts